import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material';

import { selectMainTheme } from 'app/store/fuse/settingsSlice';

interface FuseThemeProps {
	children: React.ReactNode;
}

const useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;

function FuseTheme({ children }: FuseThemeProps) {
	const direction = useSelector(({ fuse }: any) => fuse.settings.defaults.direction);
	const mainTheme = useSelector(selectMainTheme);

	useEnhancedEffect(() => {
		document.body.dir = direction;
	}, [direction]);

	// console.warn('FuseTheme:: rendered',mainTheme);
	return <ThemeProvider theme={mainTheme}>{children}</ThemeProvider>;
}

export default React.memo(FuseTheme);
